import { Card } from '@nextui-org/react';
import React from 'react';
import Typography from './Typography';
import { title } from 'process';
import theme from '../../theme';
import { AppThemeColorVariant } from '../../../types/theme';

interface ITextButton {
  onPress: () => void;
  icon?: any;
  title: string;
  disabled?: boolean;
  className?: string;
  textColorVariant?: AppThemeColorVariant;
  style?: React.CSSProperties;
}

export default function TextButton({
  style,
  className,
  disabled = false,
  textColorVariant,
  onPress,
  title,
  icon,
}: ITextButton) {

  return (
    <Card
      shadow='none'
      isPressable
      isDisabled={disabled}
      className='flex flex-row gap-1 items-center'
      style={{
        backgroundColor: 'transparent',
        padding: theme.sizing.x0_1,
        ...style
      }}
      onPress={onPress}>
      {icon}
      <Typography variant='label' colorVariant={textColorVariant ?? 'primary'} style={{fontWeight: 500}}>
        {title}
      </Typography>
    </Card>
  )
}